"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForgotPasswordSentView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
function ForgotPasswordSentView({ email, }) {
    const { t } = (0, app_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(ui_1.Stack, Object.assign({ kind: "vertical" }, { children: [(0, jsx_runtime_1.jsx)(app_1.Text, Object.assign({ tag: "h2" }, { children: t('text.checkEmail') })), (0, jsx_runtime_1.jsxs)(app_1.Text, { children: [' ', t('text.ifEmailExists'), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("b", { children: email })] })] })));
}
exports.ForgotPasswordSentView = ForgotPasswordSentView;
